<template lang="pug">
pr-wrapper.cms-detail-sidepane(fs, zi="2", bg, bgo=".75")
  .back.col.col-3.p-4(v-html="$t('press.backToBack')" v-visible="backButton")
  .cds-wrapper.surface-bg
    .cds-title.px-5.py-4
      pr-text(ref="title", :size="titleSize", weight="semibold", v-html="content.title")
      pr-text.mt-2(muted, v-if="content.subtitle", v-html="content.subtitle")
      moment.text-muted.small(v-if="content.date", date, :value="content.date")
    .cds-media.text-center.border-bottom.border-top.shadow(:class="{ withVideo: video }")
      .cds-video(:class="[content.orientation || 'horizontal']", v-if="video")
        #cds-video.h-100.w-100
      carousel.cds-carousel(
        v-else-if="gallery.length",
        :images="gallery",
        vertical,
        arrows,
        navigation="horizontal",
        :hasRoute="false",
        data-down="cms-actions|cms-description",
        @nv-back="close"
      )
    .cds-actions.px-5.pt-4.d-flex.justify-content-center(v-if="hasAction")
      actions(@cart="addToCart", :data="content", data-up="cms-carousel", data-down="cms-description", navigate, @nv-back="close")
    .cds-content
      .cds-description.px-5.py-4
        description(:content="content.description", data-up="cms-actions|cms-carousel", @nv-back="close")
</template>

<script>
import actions from "../layouts/actions.vue"
import carousel from "./helpers/carousel.vue"
import description from "./helpers/description.vue"
export default {
  name: "cms-detail-sidepane",
  components: { carousel, description, actions },
  props: ["payload"],
  data() {
    return {
      content: null,
      titleSize: "large"
    }
  },
  computed: {
    backButton() {
      return __.device.config("cms_back_button_behaviour.cms_back_button_behaviour") === "enable"
    },
    route() {
      return this.$route.params
    },
    gallery() {
      return this.content?.gallery || []
    },
    video() {
      return this.content.video || false
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    }
  },
  created() {
    this.content = this.payload
  },
  async mounted() {
    if (this.video) __.media.play(this.video, "background").then(() => this.resizeMediaWrapper("cds-video"))

    if (document.getElementById("cms-actions")?.offsetParent) _$.nav.changeScope("cms-actions")
    else if (document.getElementById("cms-description")?.offsetParent) _$.nav.changeScope("cms-description")
    else if (document.getElementById("cms-carousel")?.offsetParent) _$.nav.changeScope("cms-carousel")

    await this.$nextTick()
    this.titleSize = this.$refs.title?.$el?.offsetHeight > 90 ? "medium" : "large"
  },
  methods: {
    resizeMediaWrapper(id) {
      document.body.contains(this.$el) ? __.common.tvWindowResize(id) : __.media.stop()
    },
    close() {
      __.media.stop()
      this.$emit("close")
    },
    addToCart($event) {
      __.media.stop()
      this.$emit("cart", $event)
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-detail-sidepane {
  .cds-wrapper {
    box-shadow: -10px 0px 15px 0px rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    width: 560px;
    display: flex;
    flex-direction: column;

    .cds-title {
      flex: 0 0 auto;
    }

    .cds-media {
      vertical-align: top;
      position: relative;
      height: 317px;
      flex: 0 0 auto;

      .cds-video {
        display: inline-block;
        position: relative;

        &.vertical {
          width: 177px;
          height: 315px;
        }
        &.square {
          width: 420px;
          height: 315px;
        }
        &.horizontal {
          width: 560px;
          height: 315px;
        }
      }
      .cds-carousel {
        display: inline-block;
        position: relative;
      }
    }

    .cds-actions {
      flex: 0 0 auto;
    }
    .cds-content {
      flex: 1 0 auto;
      position: relative;
      overflow: hidden;

      .cds-description {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
      }
    }
  }
}
</style>
